import { IConfigSchema } from '@yupSchemas/configurations/configurationSchema'
import api from '@services/api/server'
import { CONFIGURATION_TYPE } from '@interfaces/configurations/enums/configurationType'
import { IConfigFile } from '@interfaces/configurations/IConfig'

export default class ConfigurationService {
    public static async createUpdate(values: FormData): Promise<IConfigSchema> {
        return (await api.post('/configurations', values)).data
    }
    public static async get(): Promise<IConfigSchema> {
        return (await api.get('/configurations/getConfigs')).data
    }
    public static async getFileByConfigType(
        value: CONFIGURATION_TYPE
    ): Promise<IConfigFile> {
        return (await api.get(`/configurations/${value}`)).data
    }
    public static async deleteFile(value: CONFIGURATION_TYPE): Promise<void> {
        await api.delete(`/configurations/${value}`)
    }
}
